module.exports = __webpack_public_path__ + "static/img/btn_09.a36ab43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/btn_09.png
// module id = rFlF
// module chunks = 4